/** 登录页面用的store */
const loginStore = {
  username: '',
  password: '',
  loginType: '',
  set(un, pw) {
    this.username = un
    this.password = pw
    localStorage.setItem('username', un)
    localStorage.setItem('password', pw)
    localStorage.setItem('rember', true)
  },
  setLoginType(lt) {
    this.loginType = lt
    localStorage.setItem('loginType', lt)
  },
  getLoginType() {
    return localStorage.getItem('loginType')
  },
  get() {
    this.password = localStorage.getItem('password')
    this.username = localStorage.getItem('username')
    return {
      username: this.username,
      password: this.password,
      rember: localStorage.getItem('rember') === 'true'
    }
  },
  clear() {
    localStorage.removeItem('password')
    localStorage.removeItem('username')
    localStorage.removeItem('rember')
  }
}

export {
  loginStore
}